import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ApiModuleEnum } from '@utils/interfaces/api-module.constant';

interface Props {
  version?: string;
  module: ApiModuleEnum;
  path: string;
}

@Injectable({
  providedIn: 'root'
})
export class UrlService {
  private readonly URL_API = environment.API;

  private normalize(segment: string): string {
    return segment.replace(/^\/+|\/+$/g, '');
  }

  public getEndpointUrl( props: Props) : string {
    const version = props.version || 'v1';
    const module = props.module ? this.normalize(props.module) : '';
    const path = this.normalize(props.path);

    if (module) {
      return `${this.URL_API}${module}/${version}/${path}`;
    }
    return `${this.URL_API}${version}/${path}`;
  }
}
